import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import * as fromShipmentAddresses from './+state/shipment-addresses.reducer';
import {ShipmentAddressesEffects} from './+state/shipment-addresses.effects';
import {ShipmentAddressesFacade} from './+state/shipment-addresses.facade';
import {SharedStoresShipmentAddressesConfig} from "./shared-stores-shipment-addresses.config";

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(
            fromShipmentAddresses.SHIPMENTADDRESSES_FEATURE_KEY,
            fromShipmentAddresses.reducer
        ),
        EffectsModule.forFeature([ShipmentAddressesEffects]),
    ],
    providers: [ShipmentAddressesFacade],
})
export class SharedStoresShipmentAddressesModule {

    static forFeature(
        config: SharedStoresShipmentAddressesConfig
    ): ModuleWithProviders<SharedStoresShipmentAddressesModule> {
        return {
            ngModule: SharedStoresShipmentAddressesModule,
            providers: [config.service]
        };
    }

}
